import { useCallback } from 'react';

import { readmeIoUrl } from '@/environment';
import { getReadmeioToken } from '@/services/api';
import { useAuth } from '@/services/auth';

export function useReadmeioLogin() {
    const { accessToken: apiKey } = useAuth();
    return useCallback(async () => {
        if (apiKey) {
            const token = await getReadmeioToken(apiKey);
            return `${readmeIoUrl}?auth_token=${token}`;
        } else {
            return readmeIoUrl;
        }
    }, [apiKey]);
}
